import { NextCBprops } from '../../authentication/wizard/types';
import { FBMOverCarousel, Item, RedeemedDepositFreespin, RedeemFreeMoneyBonus, ThunkAction } from '../types';
import { wrappedRequestApi } from './public';
import * as CONSTANTS from './constants';
import { showQueuedNotification } from '../../notifications/ducks/actions';
import { HttpMethods } from '../../../services/api-new';
import { REDUCER_NAME, clearBonus } from './index';
import { DEPOSIT_BONUS } from '~/constants/index';
import { RootState } from '~/store/types';

const SELECTED_DEPOSIT_FREESPIN_LOCAL_STORAGE = 'selectedDepositFreespin';
const SELECTED_DEPOSIT_FREEBET_LOCAL_STORAGE = 'selectedDepositFreebet';
const DEPOSIT_FREEBET_REDIRECT_URL = 'depositFreebetRedirectURL';
const SELECTE_BONUS_PACKAGE_LOCAL_STORAGE = 'selectedBonusPackageId';
const SELECTED_DEPOSIT_OPT_IN_LOCAL_STORAGE = 'selectedDepositOptIn';
const SELECTED_CAMPAIGN_ACCESS_LOCAL_STORAGE = 'selectedCampaignAccess';

export type BonusesState = {
	[REDUCER_NAME]: {
		excludedGamesForId: number[];
		activeBonusDetails: Item;
		excludedGamesForIdAreLoading: boolean;
		includedGamesForId: number[];
		includedGamesForIdAreLoading: boolean;
		availableDepositOffers: Item[];
		availableWelcomeBonusPackages: Item[];
		isBonusModalOpen: boolean;
		depositFreespinSuccess: boolean;
		depositFreebetSuccess: boolean;
		depositOptInSuccess: boolean;
		loading: boolean;
		redeemedDepositFreespin: RedeemedDepositFreespin;
		allowedForMethod: boolean;
		selectedDepositFreespin: Item;
		selectedDepositFreebet: Item;
		selectedDepositOptIn: Item;
		isRedeemingDepositFreebet: boolean;
		isRedeemingDepositOptIn: boolean;
		isDepositBonusLoading: boolean;
		continuePendingNavigation: boolean;
		redeemFreeMoneyBonus: RedeemFreeMoneyBonus;
		bonusId: number;
		selectedWelcomePackageId: number;
		bonusAddOnId: number;
		bonusAddOnOptionsId: number;
		onSelectBonus: (id: number) => void;
		onSelectFreeMoneyBonus: (id: number) => void;
		nextStep: NextCBprops;
		paginate: (props?: NextCBprops | string) => void;
		parentGoToNext: () => void;
		playerRemainingBonusBalance: number;
		hasBonusError: boolean;
		oneClickOptInMessageOpen: boolean;
		bonusMaxStakeMessageOpen: boolean;
		bonusMaxStakeMessageContent: {
			maxStakeAmount: number;
			currency: string;
		};
		bonusesHydrated: boolean;
		bonusSkipped: boolean;
		preSelectedBonus: Item;
		isPreSelectedBonusLoading: boolean;
		hasPreSelectedBonusFailure: boolean;
		fmbOverCarousel: FBMOverCarousel;
		hasFmbFailure: boolean;
		isFmbLoading: boolean;
		checkBonusFailurePayload: { errorDescription: string; errorCode: string } | undefined;
		paymentMethodIdsStr: string;
		bonusSplitCategory: string;
		hydrated: boolean;
		bid: number;
		baid: number;
		oid: number;
	};
};

// Selectors
export const selectBonuses = (state: RootState) => (state as BonusesState)[REDUCER_NAME];
export const selectExcludedGamesById = (state: RootState) => (state as BonusesState)[REDUCER_NAME].excludedGamesForId;
export const selectActiveBonusDetails = (state: RootState) => (state as BonusesState)[REDUCER_NAME].activeBonusDetails;
export const selectExcludedGamesForIdAreLoading = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].excludedGamesForIdAreLoading;
export const selectIncludedGamesById = (state: RootState) => (state as BonusesState)[REDUCER_NAME].includedGamesForId;
export const selectIncludedGamesForIdAreLoading = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].includedGamesForIdAreLoading;

export const selectAvailableDepositOffers = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].availableDepositOffers;
export const selectAvailableWelcomeBonusPackages = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].availableWelcomeBonusPackages;
export const selectIsBonusModalOpen = (state: RootState) => (state as BonusesState)[REDUCER_NAME].isBonusModalOpen;

export const selectHasBonusOffers = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].availableDepositOffers.length > 0 ||
	(state as BonusesState)[REDUCER_NAME].availableWelcomeBonusPackages.length > 0;
export const selectDepositFreespinSuccess = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].depositFreespinSuccess;
export const selectDepositFreebetSuccess = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].depositFreebetSuccess;
export const selectDepositOptInSuccess = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].depositOptInSuccess;
export const selectBonusLoading = (state: RootState) => (state as BonusesState)[REDUCER_NAME].loading;
export const selectRedeemedDepositFreespin = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].redeemedDepositFreespin;
export const selectHasDepositOffersLoaded = (state: RootState) => !(state as BonusesState)[REDUCER_NAME].loading;
export const selectAllowedForMethod = (state: RootState) => (state as BonusesState)[REDUCER_NAME].allowedForMethod;
export const selectSelectedDepositFreespin = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].selectedDepositFreespin;
export const selectSelectedDepositFreebet = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].selectedDepositFreebet;
export const selectSelectedDepositOptIn = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].selectedDepositOptIn;
export const selectIsRedeemingDepositFreebet = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].isRedeemingDepositFreebet;
export const selectIsRedeemingDepositOptIn = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].isRedeemingDepositOptIn;
export const selectIsDepositBonusLoading = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].isDepositBonusLoading;
export const selectContinuePendingNavigation = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].continuePendingNavigation;
export const selectRedeemFreeMoneyBonus = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].redeemFreeMoneyBonus;
export const selectBonusId = (state: RootState) => (state as BonusesState)[REDUCER_NAME].bonusId;
export const selectWelcomeBonusPackageId = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].selectedWelcomePackageId;
export const selectBonusAddOnId = (state: RootState) => (state as BonusesState)[REDUCER_NAME].bonusAddOnId;
export const selectBonusAddOnOptionsId = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].bonusAddOnOptionsId;
export const selectOnSelectBonus = (state: RootState) => (state as BonusesState)[REDUCER_NAME].onSelectBonus;
export const selectOnSelectFreeMoneyBonus = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].onSelectFreeMoneyBonus;
export const selectNextStep = (state: RootState) => (state as BonusesState)[REDUCER_NAME].nextStep;
export const selectPaginate = (state: RootState) => (state as BonusesState)[REDUCER_NAME].paginate;
export const selectParentGoToNext = (state: RootState) => (state as BonusesState)[REDUCER_NAME].parentGoToNext;

export const selectPlayerRemainingBonusBalance = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].playerRemainingBonusBalance;
export const selectHasBonusError = (state: RootState) => (state as BonusesState)[REDUCER_NAME].hasBonusError;
export const selectOptInMessageOpen = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].oneClickOptInMessageOpen;
export const selectBonusMaxStakeMessageOpen = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].bonusMaxStakeMessageOpen;
export const selectBonusMaxStakeMessageContent = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].bonusMaxStakeMessageContent;
export const selectBonusesHydrated = (state: RootState) => (state as BonusesState)[REDUCER_NAME].bonusesHydrated;
export const selectBonusSkipped = (state: RootState) => (state as BonusesState)[REDUCER_NAME].bonusSkipped;
export const selectPreSelectedBonus = (state: RootState) => ({
	preSelectedBonus: (state as BonusesState)[REDUCER_NAME].preSelectedBonus
		? { ...(state as BonusesState)[REDUCER_NAME].preSelectedBonus }
		: null,
	isPreSelectedBonusLoading: (state as BonusesState)[REDUCER_NAME].isPreSelectedBonusLoading,
	hasPreSelectedBonusFailure: (state as BonusesState)[REDUCER_NAME].hasPreSelectedBonusFailure
});
export const selectFmbOverCarousel = (state: RootState) => ({
	...(state as BonusesState)[REDUCER_NAME].fmbOverCarousel,
	hasFailure: (state as BonusesState)[REDUCER_NAME].hasFmbFailure,
	isLoading: (state as BonusesState)[REDUCER_NAME].isFmbLoading
});
export const selectCheckBonusFailure = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].checkBonusFailurePayload;
export const selectPaymentMethodIdsStr = (state: RootState) =>
	(state as BonusesState)[REDUCER_NAME].paymentMethodIdsStr;
export const selectBonusSplitCategory = (state: RootState) => (state as BonusesState)[REDUCER_NAME].bonusSplitCategory;

function setDepositFreespinInSessionStorage(freespinId?: number) {
	if (!window.sessionStorage) {
		return;
	}

	window.sessionStorage.setItem(SELECTED_DEPOSIT_FREESPIN_LOCAL_STORAGE, freespinId ? freespinId.toString() : '');
}

function setDepositFreespinInLocalStorage(freespinId?: number) {
	if (!window.localStorage) {
		return;
	}

	window.localStorage.setItem(SELECTED_DEPOSIT_FREESPIN_LOCAL_STORAGE, freespinId ? freespinId.toString() : '');
}

function setDepositFreebetInLocalStorage(freebetId?: number) {
	if (!window.localStorage) {
		return;
	}

	window.localStorage.setItem(SELECTED_DEPOSIT_FREEBET_LOCAL_STORAGE, freebetId ? freebetId.toString() : '');
}

function setDepositFreebetInSessionStorage(freebetId?: number) {
	if (!window.sessionStorage) {
		return;
	}

	window.sessionStorage.setItem(SELECTED_DEPOSIT_FREEBET_LOCAL_STORAGE, freebetId ? freebetId.toString() : '');
}

function setDepositOptInInLocalStorage(optInId?: number) {
	if (!window.localStorage) {
		return;
	}

	window.localStorage.setItem(SELECTED_DEPOSIT_OPT_IN_LOCAL_STORAGE, optInId ? optInId.toString() : '');
}

function setDepositOptInInSessionStorage(optInId?: number) {
	if (!window.sessionStorage) {
		return;
	}

	window.sessionStorage.setItem(SELECTED_DEPOSIT_OPT_IN_LOCAL_STORAGE, optInId ? optInId.toString() : '');
}

function setCampaignAccessInLocalStorage(id?: number) {
	if (!window.localStorage) {
		return;
	}

	window.localStorage.setItem(SELECTED_CAMPAIGN_ACCESS_LOCAL_STORAGE, id ? id.toString() : '');
}

function setCampaignAccessInSessionStorage(id?: number) {
	if (!window.sessionStorage) {
		return;
	}

	window.sessionStorage.setItem(SELECTED_CAMPAIGN_ACCESS_LOCAL_STORAGE, id ? id.toString() : '');
}

function setBonusPackageIdInLocalStorage(packageId?: number) {
	if (!window.localStorage) {
		return;
	}
	window.localStorage.setItem(SELECTE_BONUS_PACKAGE_LOCAL_STORAGE, packageId ? packageId.toString() : '');
}

function setBonusPackageIdInSessionStorage(packageId?: number) {
	if (!window.sessionStorage) {
		return;
	}
	window.sessionStorage.setItem(SELECTE_BONUS_PACKAGE_LOCAL_STORAGE, packageId ? packageId.toString() : '');
}

function setLocalDepositFreebetRedirectURL(URL: string) {
	if (!window.localStorage) {
		return;
	}
	window.localStorage.setItem(DEPOSIT_FREEBET_REDIRECT_URL, URL);
}

function setDepositFreebetRedirectURL(URL: string) {
	if (!window.sessionStorage) {
		return;
	}
	window.sessionStorage.setItem(DEPOSIT_FREEBET_REDIRECT_URL, URL);
}

export const selectFreeMoneyBonus =
	(bonusId: number, withinSidebar = false): ThunkAction =>
	async dispatch => {
		dispatch({
			type: CONSTANTS.FETCH_FREEMONEY_BONUS,
			payload: {
				pending: true,
				verifyMobile: false
			}
		});
		const params = { value: bonusId };
		const response = await wrappedRequestApi({
			endpoint: '/rest/bonus/redeemfreemoneybonus',
			payload: params,
			method: HttpMethods.POST
		});

		if (response) {
			const failure = !!('error' in response && response.error.status === 'FAILURE');

			if (
				'error' in response &&
				failure &&
				response.error.errorCode &&
				['BONUS_ADD_NEEDS_VERIFIED_EMAIL', 'BONUS_ADD_NEEDS_VERIFIED_EMAIL_MOBILE'].includes(
					response.error.errorCode
				)
			) {
				dispatch(
					showQueuedNotification({
						message: response.error.errorDescription,
						color: 'red',
						autoHide: true,
						openInSidebar: withinSidebar
					})
				);
				return dispatch({
					type: CONSTANTS.FETCH_FREEMONEY_BONUS,
					payload: {
						pending: false
					}
				});
			}

			const verifyMobile =
				failure && ('error' in response ? response.error.errorCode : '') === 'BONUS_ADD_NEEDS_VERIFIED_MOBILE';
			return dispatch({
				type: CONSTANTS.FETCH_FREEMONEY_BONUS,
				payload: {
					pending: false,
					result: response,
					verifyMobile
				}
			});
		}
		return dispatch({
			type: CONSTANTS.FETCH_FREEMONEY_BONUS,
			payload: {
				pending: false
			}
		});
	};

export const selectDepositFreespin =
	(freespin: Item): ThunkAction =>
	dispatch => {
		dispatch(clearBonus());
		setDepositFreespinInSessionStorage(freespin.id);
		setDepositFreespinInLocalStorage(freespin.id);
		dispatch({ type: CONSTANTS.SELECT_DEPOSIT_FREESPIN, payload: freespin });
	};

export const selectDepositFreebet =
	(freebet: Item): ThunkAction =>
	dispatch => {
		dispatch(clearBonus());
		setDepositFreebetInSessionStorage(freebet.id);
		setDepositFreebetInLocalStorage(freebet.id);
		dispatch({ type: CONSTANTS.SELECT_DEPOSIT_FREEBET, payload: freebet });
	};

export const selectDepositOptIn =
	(optIn: Item): ThunkAction =>
	dispatch => {
		dispatch(clearBonus());
		setDepositOptInInSessionStorage(optIn.id);
		setDepositOptInInLocalStorage(optIn.id);
		dispatch({ type: CONSTANTS.SELECT_DEPOSIT_OPT_IN, payload: optIn });
	};

export const selectCampaignAccess =
	(item: Item): ThunkAction =>
	dispatch => {
		dispatch(clearBonus());
		setCampaignAccessInSessionStorage(item.id);
		setCampaignAccessInLocalStorage(item.id);
		dispatch({ type: CONSTANTS.SELECT_CAMPAIGN_ACCESS, payload: item });
	};

export function selectWelcomeBonusPackage(
	id?: number,
	redirect?: string,
	bonuses?: Item[],
	paymentMethodIdsStr?: string
): ThunkAction {
	return dispatch => {
		const allowedForMethod = true;
		const continuePendingNavigation = allowedForMethod;
		const optionalDepositBonus =
			bonuses && bonuses.length > 0 && bonuses.find(bonus => bonus.type === DEPOSIT_BONUS);

		// IF has redirect URL add coockie here.
		if (redirect) {
			setDepositFreebetRedirectURL(JSON.stringify(redirect));
			setLocalDepositFreebetRedirectURL(JSON.stringify(redirect));
			setBonusPackageIdInSessionStorage(id);
			setBonusPackageIdInLocalStorage(id);
		}

		return dispatch({
			type: CONSTANTS.SELECT_BONUS_PACKAGE,
			payload: {
				packageId: id,
				welcomeBonusPackageId: id,
				bonusId: optionalDepositBonus && 'id' in optionalDepositBonus ? optionalDepositBonus?.id : '',
				paymentMethodIdsStr,
				allowedForMethod: true,
				continuePendingNavigation
			}
		});
	};
}

export const selectBonus =
	(bonusId?: number): ThunkAction =>
	(dispatch, getState) => {
		const { availableBonusesOnId } = getState().bonuses as { availableBonusesOnId: { [key: number]: Item } };
		const theBonus = availableBonusesOnId && bonusId && availableBonusesOnId[bonusId];
		const paymentMethodIdsStr = theBonus && theBonus.paymentMethodIdsStr;
		const allowedForMethod = true;

		const continuePendingNavigation = allowedForMethod;
		dispatch({
			type: CONSTANTS.SELECT_BONUS,
			payload: {
				...(bonusId ? { bonusId, bid: bonusId } : {}),
				// ...(bonusAddOnId ? { bonusAddOnId, baid: bonusAddOnId } : {}),
				// ...(bonusAddOnOptionsId ? { bonusAddOnOptionsId, oid: bonusAddOnOptionsId } : {}),
				paymentMethodIdsStr,
				allowedForMethod,
				continuePendingNavigation
			}
		});
	};
